module.exports = __webpack_public_path__ + "img/logo_pv_branco.050a361d.png";